import { useEffect, useState } from 'react';
import { playVersion } from '../services/versions';

/**
 * The version's build address with a play token minted when the caller mounts, so a frame opened long after the page
 * loaded carries a token that is still valid. Null until the server answers; the page's own address when it does not.
 */
export function useFreshBuildUrl(projectId: string, versionId: string, pageBuildUrl: string): string | null {
  const [buildUrl, setBuildUrl] = useState<string | null>(null);

  useEffect(() => {
    let current = true;
    playVersion(projectId, versionId)
      .then(({ isReady, webGlPath }) => (isReady && webGlPath ? webGlPath : pageBuildUrl))
      .catch(() => pageBuildUrl)
      .then((next) => {
        if (current) setBuildUrl(next);
      });
    return () => {
      current = false;
    };
  }, [projectId, versionId, pageBuildUrl]);

  return buildUrl;
}
